import { BalenaSdk, sdk } from '../../api-utils';

export const getApplications = async (
	filter?: BalenaSdk.PineFilter<BalenaSdk.Application>,
	top?: number,
	orderBy?: string,
) => {
	const options: BalenaSdk.PineOptionsWithSelect<BalenaSdk.Application> = {
		$orderby: orderBy || 'created_at desc',
		$select: ['id', 'app_name', 'is_of__class'],
		$expand: {
			is_for__device_type: {
				$select: ['slug'],
			},
			public_organization: {
				$select: ['name'],
			},
			should_be_running__release: {
				$select: ['contract', 'raw_version'],
				$filter: {
					status: 'success',
					is_final: true,
				},
			},
		},
		$filter: {
			is_host: false,
			is_discoverable: true,
		},
	};
	if (top != null) {
		options.$top = top;
	}

	if (filter != null) {
		options.$filter = { ...options.$filter, ...filter };
	}

	return await sdk.models.application.getAll(options);
};
